module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"agents":"Agent","quantity":"Quantity Month Old Chicks"},"es":{},"sw":{}}')
  delete Component.options._Ctor
}
